<template>
  <div class="backColor no-print">
    <div class="links">
      <div class="view is-flex">
        <div class="grid-view is-flex">
          <div v-if="!projects.length" class="no-results has-text-grey-light subtitle has-text-centered">
            <span v-if="canEdit"> {{ $t("projectPage.createLinkedProjects") }} <span class="cursor-pointer has-text-primary" @click="linksMode('Add')">+{{ $t("projectPage.add") }}</span>.</span>
          </div>
          <div class="project-container" v-for="project in projects" :key="project.id">
            <judge-team-project :project="project" :key="project.id" :showFollow="false" :linkStyles="true" @click="updateStateProjectID(project.id)"></judge-team-project>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JudgeTeamProject from '@/components/Cards/ProjectCards/Types/JudgeTeamProject'
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import socket from '@/libs/socket'
import state from '../state'
import componentState from '@/mixins/component-state'
import i18n from '@/i18n'

export default {

  components: {
    JudgeTeamProject,
    InfiniteScroll
  },

  mixins: [componentState],

  data: function () {
    return {
      loading: false,
      subscribed: false,
      fetchCount: 0,
      tags: {},
      searchData: { query: '', limit: 6, offset: 0, projects: [], lastQuery: '', hasMore: false },
      searched: false,
      linksState: 'View',
      projectType: 'linked',
      hideLinkedProjects: false
    }
  },

  computed: {
    isStory: function () {
      return this.$route.name === 'viewStory'
    },
    projects: function () {
      return this.$store.getters.getJudgingTeamProjects(this.projectID) ?? []
    },
    canEdit: function () {
      return this._get(state.project.permissions.edit, false)
    },
    project: function () {
      return this.projectID ? this.$store.getters.project(this.projectID) || {} : {}
    },
    projectID: function () {
      return this._get(state.project.id)
    },
    type: function () {
      return this.$isEngCom ? 'Linked Stories' : i18n.t('projectPage.linkedProjects')
    }
  },

  mounted: function () {
    this.$store.dispatch('fetchJudgingTeamProjects', this.projectID)
  },

  destroyed: function () {
    if (this.subscribed) {
      this.subscribed = false
      socket.unsubscribe('project', this.project.id, 'linked')
    }
  },

  methods: {
    linked: function () {
      this.projectType = 'linked'
    },
    recommended: function () {
      this.projectType = 'recommended'
    },
    fetchProjects: function () {
      if (!this.project.id || this.loading) {
        return
      }

      this.loading = true
      this.$store.dispatch('getLinkedProjects', { project: this.project }).then((projects) => {
        this.fetchCount++
        this.hideLinkedProjects = !this.canEdit && projects.length === 0
      }).catch(() => {})
      this.loading = false
    },
    search: function () {
      if (this.searchData.query.length === 0) {
        this.searched = false
        return
      }

      if (this.searchData.query !== this.searchData.lastQuery) {
        this.searchData.projects = []
        this.searchData.offset = 0
        this.searchData.hasMore = false
      } else {
        this.searchData.offset += this.searchData.limit
      }

      this.$store.dispatch('getProjects', { limit: this.searchData.limit, offset: this.searchData.offset, query: this.searchData.query }).then((response) => {
        let matches = response.projects
        matches = matches.filter(elem => elem.id !== this.project.id)
        this.searchData.projects.push.apply(this.searchData.projects, matches)
        this.searchData.lastQuery = this.searchData.query
        this.searchData.hasMore = response.hasMore
      }).catch((messages) => {})
      this.searched = true
    },
    searchMore: function () {
      if (this.searchData.hasMore) {
        this.searchData.lastQuery = this.searchData.query
        this.search()
      }
    },
    removeLink: function (project) {
      this.$store.dispatch('removeLinkedProject', { parent: this.project, child: project }).then((response) => {
        socket.delete('project', this.project.id, 'link')
      }).catch((messages) => {})
    },
    addLink: function (project) {
      if (this.existingLink(project.id)) {
        return
      }
      this.$store.dispatch('addLinkedProject', { parent: this.project, child: project }).then((response) => {
        socket.add('project', this.project.id, 'link')
      }).catch((messages) => {})
    },
    existingLink: function (projectID) {
      const linkedList = this.$store.getters.linkedProjects(this.project.id)
      const result = linkedList.filter(elem => elem.id === projectID)
      if (result.length > 0) {
        return true
      } else {
        return false
      }
    },
    updateStateProjectID: function (projectID) {
      this._set(state.project.id, projectID)
    },
    linksMode: function (type) {
      this.linksState = type
      if (type === 'Add' || type === 'Edit') {
        this.linked()
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .backColor {
    background:#f2f2f2;
  }

  .view {
    justify-content: center;
  }

  .links {
    margin:0 auto;
    background:#fff;
    padding: 0 1rem;
    padding-bottom: 4rem;
    @include tablet-only{
      max-width:100%;
    }
    @include mobile{
      max-width: 100%;
      padding: 0;
    }
    .tabs{
      margin-top: 1rem;
      margin-bottom: 0;
      padding: 0 1rem;
      .type-tab{
        text-align: left;
        font-weight: bold;
        color: #dbdbdb;
      }
      .bold{
        color: #363636;
      }
      cursor: pointer
    }
  }

  .add{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    .input {
      border-radius: 2rem;
    }
  }
  .search {
    flex-grow: 1;
    .control {
      .input {
        border-radius: 2.5rem 0 0 2.5rem;
        font-size: 0.75rem;
        height: 2.5rem;
        width: 90%;
        padding-left: 1.25rem;
        padding-right: 0;
        position: relative;
        border-color: $primary;
        border-right: none;
        box-shadow: none;
      }

      .icon {
        color: $primary;
        margin-right: 0.5rem;
        pointer-events: auto;
        cursor: pointer;
        height: 2.5rem;
        width: 3rem;
        position: relative;
        border: 1px solid $primary;
        border-left: none;
        border-radius: 0 2.5rem 2.5rem 0;
      }
    }
  }
  .project:hover {
    border-radius: 1rem;
  }

  .project-container {
    width: 33%;
    min-width: 33%;
    display: inline-block;
    position: relative;
    z-index: 2;
    cursor: pointer;
    @include mobile {
      width: 100%;
    }
  }

  .project {
    width: 100%;
  }

  .remove-button, .add-button {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    margin: auto;
    top: 30%;
    width: inherit;
    max-width: 150px;
    @include mobile {
      top: 40%;
    }
  }
  .no-results, .pre-search {
    width: 70%;
    margin: 2rem 0;
    @include mobile {
      margin: 2rem;
    }
  }
  .no-links {
    padding-top: 5rem;
    padding-bottom: 3rem;
  }
  .is-greyed {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .is-cursor-disabled {
    cursor: not-allowed;
  }
  .grid-view{
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    .project-container{
      max-width: 400px;
      @include tablet-only {
        .card-container {
          padding: 1rem;
        }
      }
    }
  }
  .links-head {
    width: 100%;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    height: 55px;
    align-items: center;
    border-bottom: 1px solid whitesmoke;
    align-items: center;
    flex-wrap: nowrap;
    padding-top: 0;
    @include mobile {
      padding: 0.5rem;
    }
    .title{
      display: inline-block;
      padding-right: 0.7rem;
    }
    .link-button {
      margin-right: 1rem;
    }
  }

  .done-btn {
    display: flex;
  }

  .search-btn {
    margin-right: 2rem;
    @include mobile {
      margin-right: 0;
    }
  }

  .section-title {
    padding: 1rem 0 0 1rem;
  }
</style>
